import { Component, Input } from '@angular/core';
import { BaseViewComponent, DesignBlockScope, WebsiteMode, WebsitePageScope } from '@sb/library/base';
import { WebsiteBlockDisplayItem, WebsiteBlockType, WebsiteHostingType, WebsiteRenderContextDisplayItem, WebsiteScriptCodeDisplayItem } from '@sb/library/data-models';

@Component({
    selector: 'lib-website-block',
    templateUrl: './website-block.component.html',
    styleUrls: ['./website-block.component.scss']
})
export class WebsiteBlockComponent extends BaseViewComponent implements DesignBlockScope {

    Scope = this.SetScope({
        Implements: [WebsitePageScope, DesignBlockScope]
    });

    readonly websiteMode: WebsiteMode = WebsiteMode.Live;
    readonly websiteBlockCount: number = 1;

    HandleBlockAction = NotSupported;
    HandleImageAction = NotSupported;

    @Input() websiteBlockData!: WebsiteBlockDisplayItem;
    @Input() renderContext!: WebsiteRenderContextDisplayItem;
    @Input() hostingType: WebsiteHostingType = WebsiteHostingType.InternalDomain;
    @Input() scriptCodes!: WebsiteScriptCodeDisplayItem[];

    get WebsiteBlockType(): typeof WebsiteBlockType {
        return WebsiteBlockType;
    }

    get WebsiteBlockDisplayItem(): typeof WebsiteBlockDisplayItem {
        return WebsiteBlockDisplayItem;
    }

    get WebsiteMode(): typeof WebsiteMode {
        return WebsiteMode;
    }
}

function NotSupported() { throw Error('Not implemented for widget mode'); }
